import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule }  from '@angular/forms';
import { SharedModule }       from '@shared/shared.module';

import { UserService }  from '@core/services/user.service';
import { SettingService } from '@core/services/setting.service'

import { EmailValidator } from '@shared/directives/email.validator.directive';

import { routing }  from './account.routing';
//import { RegistrationFormComponent }   from './registration-form/registration-form.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { VendasService } from '@core/services/vendas.service'

@NgModule({
  imports: [
    CommonModule,FormsModule,ReactiveFormsModule,routing,SharedModule
  ],
  declarations: [EmailValidator, LoginFormComponent],
  providers:    [ UserService, SettingService, VendasService ]
})
export class AccountModule { }
